









































import Vue from 'vue';

import ZenMultiselect from '@reciprocity/multiselect';
import { cloneDeep, isArray, find } from 'lodash';
import { VBTooltip } from 'bootstrap-vue';
import { getTooltipOptions, getPersonFullLabel } from '@/components/tooltips/utils';

export interface PeopleDropdownEntry {
  id: number;
  label: string;
  value: string;
  role: string;
}

export default Vue.extend({
  name: 'PeopleDropdown',
  components: {
    ZenMultiselect,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    people: {
      type: Array as () => PeopleDropdownEntry[],
      default: () => [],
    },
    value: {
      type: Array as () => PeopleDropdownEntry[],
      default: () => [],
    },
    disabledRoles: {
      type: Array as () => String[],
      default: () => ['Reader'],
    },
    hiddenRoles: {
      type: Array as () => String[],
      default: () => ['No Access'],
    },
    // Vue-multiselect exposed props:
    placeholder: {
      type: String,
      default: '',
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    multiselectCounter: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myValue: [],
    };
  },
  computed: {
    isMultiple() {
      return isArray(this.myValue);
    },
    entries() {
      return this.peopleToEntries(this.people);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.myValue = this.idsToUsers(value);
      },
      deep: true,
    },
  },
  mounted() {
    this.myValue = this.idsToUsers(this.value);
  },
  methods: {
    getPersonFullLabel,
    getTooltipOptions,

    peopleToEntries(people: PeopleDropdownEntry[]) {
      let result = cloneDeep(people)
        .filter(o => o.role && this.hiddenRoles.findIndex((a: any) => a === o.role) === -1)
        .map(o => ({
          $isDisabled: this.disabledRoles.findIndex(a => a === o.role) > -1,
          ...o,
        }));

      return result;
    },

    idsToUsers(ids: Number[]): PeopleDropdownEntry[] {
      const findUser = (userId: any) => find(this.entries, (user: any) => user.id == userId);
      return (ids || []).map(findUser).filter(o => o) as PeopleDropdownEntry[];
    },

    onChange(value: Object[]) {
      this.$emit(
        'input',
        value.map(o => o.id)
      );
    },
  },
});
